/**
 * Lazy-load Dutchie carousel embeds when placeholders near the viewport.
 */
export default function initDutchieCarouselLazy() {
	const placeholders = document.querySelectorAll('.dutchie-carousel-lazy[data-dutchie-carousel-src]');
	if (!placeholders.length) {
		return;
	}

	const loadCarousel = (el) => {
		const src = el.getAttribute('data-dutchie-carousel-src');
		if (!src || el.dataset.dutchieCarouselLoaded === 'true') {
			return;
		}

		el.dataset.dutchieCarouselLoaded = 'true';

		const script = document.createElement('script');
		script.async = true;
		script.src = src;

		const id = el.getAttribute('data-dutchie-carousel-id');
		if (id) {
			script.id = id;
		}

		el.replaceWith(script);
	};

	if (!('IntersectionObserver' in window)) {
		placeholders.forEach(loadCarousel);
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}
				observer.unobserve(entry.target);
				loadCarousel(entry.target);
			});
		},
		{ rootMargin: '300px 0px', threshold: 0 }
	);

	placeholders.forEach((el) => observer.observe(el));
}
